export enum ApplePayGatewayType {
    BRAINTREE = 'braintree',
}
